export default __webpack_public_path__ + "static/media/mc_4Suit.ab733753.png";